import { ButtonWrapper, ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { CreateBtn } from "../styles";
import { useTranslation } from "react-i18next";
import { ActionTypes } from "shared/pages/teams/const/ActionTypes";
import { DropdowCreateProjectnWrapper } from "../styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { CustomDropdown } from "../styles";
import { AppTester } from "supporting";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Designer, Team } from "@brg/api";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useProfile, useAuth } from "@brg/auth";
import { LayoutConst } from "core";
import { useDispatch, useSelector } from "react-redux";
import { bProfile } from "core/utils/bProfile";
import { SwitcherButtons } from "./SwitcherButtons";
import { SpecialTypeButtons } from "./SpecialTypeButtons";
import { CreateLinkTo } from "shared/constants/linkTo";
import { LinkTo } from "shared/constants/linkTo";
import { isSpecialButton } from "shared/pages/teams/components/SpecialDropdownButtons";
import { setTeamLongread } from "shared/reducers/ViewTypeSlice";
import urlApi from "shared/actions/urlApi";
import useContextButtons from "../hooks/useContextButtons";

//@todo типизировать Team
const TeamButtons: FC<{
    team: any,
    disciplinesRaw: any,
    currentTab?: string
}> = ({
    team,
    disciplinesRaw,
    currentTab,
}) => {
    const { t, i18n: { language } } = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const { token, emit } = useAuth();
    const history = useHistory();
    const is430 = useBreakpoint(470);
    const is992 = useBreakpoint(992);
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
    const isDafes = AppTester.isGeoDafes();
    const isMainPage = isMain || isForcedLanding;
    const isDafesMain = isDafes && isMainPage;
    const isLectureMedia = AppTester.isLectureMediiia();
    const isAcademy = AppTester.isAcademy();
    const isProDeziiign = AppTester.isProDeziiign();
    const isProHSE = AppTester.isProHSE();
    const isHseSpacePro = AppTester.isHseSpace() && location.pathname.startsWith('/pro');
    const isBooks = AppTester.isBooks() && !AppTester.isBooksMediiia();
    const isLMSHSE = AppTester.isLMSHSE();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isMobile = useIsMobile();

    const isGeograffee = AppTester.isGeograffee();
    const isBooksMain = AppTester.isBooksMain();
    const isMediiiaMain = AppTester.isMediiiaMain();
    const isHSEDesign = AppTester.isHSEDesign();
    const isHseAnimation = AppTester.isHseAnimation()
    const {
        contextName: context,
        isCanCreateProject,
        teamId,
        moderationType,
        isLongreadDisabled,
    } = team;

    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
    const isGameDeziiign = AppTester.isGameDeziiign();
    const BookDesign = useMemo(() => (context === 'books_deziiign'), [context])

    const isDvaDesign = AppTester.isDvaDesign();
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
    const teamHasLongread = (!!team?.longread || team?.longreadEntityLink !== '') && !isLongreadDisabled;
    const isLMSTeam = useMemo(() => moderationType === ModerationType.LMS, [moderationType])
    const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;
    const isModulesLMSHSE = team?.moderationType === ModerationType.LMS;
    const isCompetitions = false; // This needs to be defined based on context
    const isKiiidsArt = AppTester.isKiiidsArt();
    const isDesignBooks = AppTester.isBooksMain();
    const isGalllleryBooks = AppTester.isBooksGallllery();
    const isPro = AppTester.isProDeziiign();
    const isHseSpace = AppTester.isHseSpace();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isCreativeHSE = AppTester.isContext('hsecreative');
    const isLMSHSECreative = AppTester.isContext('lmscreative');
    const isDeziiign = AppTester.isDeziiign();
    const isCompetitionEducation = AppTester.isCompetitionEducation();
    const isCompetition = AppTester.isCompetition();
    const shouldVisibleLgOrProjects = useMemo(() => (!!team?.isShowLongread || !!team?.isShowGridFirst), [team]);
    const visibleLGSelector = useSelector((state: any) => state.vt.longreadVisible);
    const hasForcedLanding = teamHasLongread;
    const visibleLG = teamHasLongread && (hasForcedLanding ? (teamHasLongread && ((team.isShowGridFirst && isForcedLanding) || (!team.isShowGridFirst && !isForcedLanding))) : visibleLGSelector);

    const isDropdownEnabled = isProDeziiign || isProHSE || isHseSpacePro;
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
    const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
    const onDropdownChange = (option: { label: string; value: string } | null) => {
        if (option) {
            setNavProTypeValue(option);
            history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
        }
    };

    const { contextButtons, hideSwitcherButtons } = useContextButtons(team, currentTab);
    
    useEffect(() => {
        //todo вынести дропдаун в отдельный компонент
        if (isDropdownEnabled) {
            urlApi()
                .getLendPresTagsTree(language)
                .then((tree: any[]) => {
                    const root = tree?.[0] || { additionalTags: [] };

                    const options = (root.additionalTags || []).map((tag: any) => {
                        const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === language);
                        return {
                            label: nameObj?.name || tag.title,
                            value: tag.tagId,
                        };
                    });

                    setProTypeOptions(options);

                    setNavProTypeValue(prev => {
                        if (!prev) return null;
                        return options.find((opt: any) => opt.value === prev.value) || null;
                    });
                })
                .catch((err: any) => {
                    console.error('Не удалось загрузить типы проектов', err);
                });
        }
    }, [language, isDropdownEnabled]);

    const { isChannel } = isTeamChannel(moderationType);

    const owner = useMemo(
        () => (profile && team && team?.owners?.find(
            (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
        , [team, isChannel]) as Designer | undefined

    const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);

    const [teamPageLink, brndLink] = useMemo(() => {
        const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
        return [`${basePath}`, `${basePath}/brnd`];
    }, [isLMSTeam, isMainPageTeam, context, teamId])

    const isCGRAVE = AppTester.isCGRAVE();
    const isShouldVisibleLMSButton = useMemo(
        () =>
            Boolean(
                (isLMSHSE || team?.moderationType == ModerationType.LMS) &&
                (team && (!!owner || isModer))
            ),
        [isLMSHSE, team, owner, isModer]
    );
    const createButtonTitle = useMemo(
        () =>
            isModulesLMSHSE || isLMSHSE
                ? t("nav.create_button.create_modul")
                : isCompetitions
                    ? t("nav.create_button.create_competition")
                    : isKiiidsArt ? t('nav.create_button.add_work_kiiids')
                        : isBooks || isDesignBooks || isGalllleryBooks
                            ? t("nav.create_button.create_book")
                            : isProDeziiign || isProHSE
                                ? t("nav.create_button.create_presentation")
                                : t("nav.create_button.create_project"),
        [isModulesLMSHSE, t, isCompetitions, isKiiidsArt, isBooks, isDesignBooks, isGalllleryBooks, isProDeziiign, isProHSE]
    );

    const shouldVisibleLGButton = useMemo(
        () => ((!!team?.isShowGridFirst || !!team?.isShowLongread) && teamHasLongread /*&& !visibleLG*/), [shouldVisibleLgOrProjects, visibleLG, team, teamHasLongread]);

    const setVisibleLG = (value: boolean) => {
        dispatch(setTeamLongread(value))
    }

    const onCreateClick = useCallback(() => {
        if (token) {
            history.push(BookDesign || isBooks ? CreateLinkTo.bookCreate() : CreateLinkTo.projectCreate());
        } else {
            emit('login');
        }
    }, [token, history, emit, BookDesign]);


    const buttonsTitle = useMemo(() => {
        if (teamId === 'b6a473594aee4b698cf0e49f52880df0') {
            return {
                titleFilled: language === 'ru' ? 'Перейти на сайт Школы дизайна НИУ ВШЭ' : 'Go to the HSE School of Design website',
                titleHollow: language === 'ru' ? 'Информация для абитуриентов Школы дизайна НИУ ВШЭ' : 'Information for applicants | HSE Art and Design School',
            }
        }
    }, [teamId, language])


    const isLMSContext = useMemo(() => context === 'lms' && !isLectureMedia, [context, isLectureMedia])

    const hasTeamEmblem = useMemo(
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
        , [team]);


    const shouldDisplayEmblem = useMemo(() => (hasTeamEmblem || (isDafesMain)), [hasTeamEmblem, isDafesMain]);

    return (!!contextButtons?.length ?
        <ButtonWrapper
            fs
            className={'action-buttons'}
            buttonsWrap={contextButtons?.length > 2}
            hasEmblem={shouldDisplayEmblem && is992 && !is743}
            isLms={isLMSContext}
            emblemVisible={shouldDisplayEmblem}
            isFashionDeziiign={isFashionDeziiign}
        >
            {
                is430 && isCanCreateProject && (
                    <CreateBtn
                        className={'context-button'}
                        onClick={onCreateClick}
                        disabled={isTeamPreview}
                        importantStyles={!isHSEDesign && !BookDesign && !isCGRAVE && !isDeziiign && !isHseAnimation}
                        fixedSize
                    >
                        {createButtonTitle}
                    </CreateBtn>
                )
            }
            {contextButtons?.filter((button: any) => button.actionType !== ActionTypes.longread).map(({
                type,
                text: textRaw,
                textMobile,
                href,
                anchor,
                bgColor,
                actionType,
                hidden
            }: any) => {
                const text = isMobile ? (textMobile || textRaw) : textRaw;
                const isAnchor = !!anchor?.value?.length;
                const currentUtmParams = new URLSearchParams(window.location.search);
                const link = type?.includes('anchor')
                    ? `#${anchor?.value}`
                    : href?.includes('form')
                        ? `${href}${currentUtmParams.toString() ? `?${currentUtmParams.toString()}` : ''}`
                        : href?.includes('@') && !href?.startsWith('mailto:') && !href?.startsWith('http')
                            ? `mailto:${href}`
                            : href;
                const isMailtoLink = link?.startsWith('mailto:');
                const isButtonHidden = hidden;


                if (isButtonHidden || !text?.length) return false;

                if (isSpecialButton(actionType || '')) {
                    return (
                        <SpecialTypeButtons
                            hide={hideSwitcherButtons}
                            type={type}
                            text={text}
                            specialType={actionType}
                            team={team}
                        />
                    )
                }

                if (actionType === ActionTypes.showcase && shouldVisibleLGButton) {
                    return <SwitcherButtons hide={hideSwitcherButtons} isShouldVisibleLMSButton={isShouldVisibleLMSButton}
                        type={type} text={text} action={() => { /*setQueryParams({ lgvisible: true });*/
                            setVisibleLG(true)
                            if (hasForcedLanding) {
                                history.push(team.isShowGridFirst ? brndLink : teamPageLink);
                            }
                        }} />
                }

                if (actionType === ActionTypes.showcase && !shouldVisibleLGButton) {
                    return false;
                }

                if (type === 'filled') {
                    return (
                        <>
                            {isAnchor && !isMailtoLink ? (
                                <ExploreButtonFilled className={'filled-button context-button'}
                                    // importantStyles={!isHSEDesign && !BookDesign}
                                    fixedSize
                                    customBG={bgColor}
                                    isGreenBG={isAgeytomesh}
                                    disabled={isTeamPreview}
                                    onClick={() => {
                                        history.push(location.pathname + link)
                                        setVisibleLG(true);
                                    }}
                                >
                                    {text}
                                </ExploreButtonFilled>
                            ) : (
                                <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleFilled } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                    <ExploreButtonFilled
                                        className={'filled-button'}
                                        // importantStyles={!isHSEDesign && !BookDesign}
                                        fixedSize
                                        customBG={bgColor}
                                        isGreenBG={isAgeytomesh}
                                        disabled={isTeamPreview}
                                    >
                                        {text}
                                    </ExploreButtonFilled>
                                </a>
                            )}
                        </>
                    )
                }

                if (type === 'filled-blue') {
                    return (
                        <>
                            {isAnchor && !isMailtoLink ? (
                                <ExploreButtonFilled className={'filled-button context-button'}
                                    // importantStyles={!isHSEDesign && !BookDesign}
                                    fixedSize
                                    customBG="#182c65"
                                    isGreenBG={isAgeytomesh}
                                    disabled={isTeamPreview}
                                    onClick={() => {
                                        history.push(location.pathname + link)
                                        setVisibleLG(true);
                                    }}
                                >
                                    {text}
                                </ExploreButtonFilled>
                            ) : (
                                <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleFilled } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                    <ExploreButtonFilled
                                        className={'filled-button'}
                                        // importantStyles={!isHSEDesign && !BookDesign}
                                        fixedSize
                                        customBG="#182c65"
                                        isGreenBG={isAgeytomesh}
                                        disabled={isTeamPreview}
                                    >
                                        {text}
                                    </ExploreButtonFilled>
                                </a>
                            )}
                        </>
                    )
                }
                return (
                    <>
                        {isAnchor && !isMailtoLink ? (
                            <ExploreButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button anchor-button context-button'}
                                onClick={() => {
                                    if (hasForcedLanding) {
                                        history.push(team.isShowGridFirst ? brndLink : teamPageLink);
                                    } else {
                                        setVisibleLG(true)
                                    }
                                    setTimeout(() => {
                                        history.replace(window.location.pathname + link)
                                    }, 100)
                                }}>
                                {text}
                            </ExploreButtonHollow>
                        ) : (
                            <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleHollow } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                <ExploreButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'}>
                                    {text}
                                </ExploreButtonHollow>
                            </a>
                        )}
                    </>
                )
            })}

        </ButtonWrapper> : (!isShouldVisibleLMSButton && !(isProDeziiign || isPro || isHseSpacePro || isMediiiaMain || isAcademy || isHseSpace || isDeziiign || isGameDeziiign || isGreenAward || isAdcrDafesNet || isCreativeHSE || isLMSHSECreative || isHSEDesign || isGalllleryArt || isGreenAward || isCompetitionEducation || isCompetition)) ? null : isCanCreateProject && is430 ? (
            <ButtonWrapper
                fs
                className={'action-buttons'}
                buttonsWrap={contextButtons?.length === 3}
                hasEmblem={shouldDisplayEmblem && is992 && !is743}
                isLms={isLMSContext}
                emblemVisible={shouldDisplayEmblem}
                isFashionDeziiign={isFashionDeziiign}
            >
                {isDropdownEnabled ? (
                    <DropdowCreateProjectnWrapper>
                        <ProjectEditPageGridInput isTeamEdit isColumns>
                            <CustomDropdown
                                value={navProTypeValue}
                                onChange={onDropdownChange}
                                options={proTypeOptions}
                                placeholder={isGeograffee ? t('nav.create_project') :
                                    isBooksMain ? t('nav.create_button.create_book') :
                                        isProDeziiign || isPro || isHseSpacePro ? t('nav.create_button.create_presentation') :
                                            t('nav.create')}
                            />
                        </ProjectEditPageGridInput>

                    </DropdowCreateProjectnWrapper>
                ) : (
                    <CreateBtn
                        className='context-button'
                        onClick={onCreateClick}
                        disabled={isTeamPreview}
                        // importantStyles={!isHSEDesign && !BookDesign}
                        fixedSize
                    >
                        {createButtonTitle}
                    </CreateBtn>
                )}
            </ButtonWrapper>
        ) : null);
}

export default TeamButtons;import { ButtonWrapper, ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import { CreateBtn } from "../styles";
import { useTranslation } from "react-i18next";
import { ActionTypes } from "shared/pages/teams/const/ActionTypes";
import { DropdowCreateProjectnWrapper } from "../styles";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { CustomDropdown } from "../styles";
import { AppTester } from "supporting";
import { useBreakpoint, useIsMobile } from "@brg/ui";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { Designer, Team } from "@brg/api";
import { isTeamChannel, ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useProfile, useAuth } from "@brg/auth";
import { LayoutConst } from "core";
import { useDispatch, useSelector } from "react-redux";
import { bProfile } from "core/utils/bProfile";
import { SwitcherButtons } from "./SwitcherButtons";
import { SpecialTypeButtons } from "./SpecialTypeButtons";
import { CreateLinkTo } from "shared/constants/linkTo";
import { LinkTo } from "shared/constants/linkTo";
import { isSpecialButton } from "shared/pages/teams/components/SpecialDropdownButtons";
import { setTeamLongread } from "shared/reducers/ViewTypeSlice";
import urlApi from "shared/actions/urlApi";
import useContextButtons from "../hooks/useContextButtons";

//@todo типизировать Team
const TeamButtons: FC<{
    team: any,
    disciplinesRaw: any,
    currentTab?: string
}> = ({
    team,
    disciplinesRaw,
    currentTab,
}) => {
    const { t, i18n: { language } } = useTranslation();
    const profile = useProfile();
    const dispatch = useDispatch();
    const { token, emit } = useAuth();
    const history = useHistory();
    const is430 = useBreakpoint(470);
    const is992 = useBreakpoint(992);
    const is743 = useBreakpoint(LayoutConst.screen.s - 1);
    const isMain = !!useRouteMatch(['/'])?.isExact;
    const isForcedLanding = !!useRouteMatch(['/brnd', '/teams/:teamName/brnd'])?.isExact
    const isDafes = AppTester.isGeoDafes();
    const isMainPage = isMain || isForcedLanding;
    const isDafesMain = isDafes && isMainPage;
    const isLectureMedia = AppTester.isLectureMediiia();
    const isAcademy = AppTester.isAcademy();
    const isProDeziiign = AppTester.isProDeziiign();
    const isProHSE = AppTester.isProHSE();
    const isHseSpacePro = AppTester.isHseSpace() && location.pathname.startsWith('/pro');
    const isBooks = AppTester.isBooks() && !AppTester.isBooksMediiia();
    const isLMSHSE = AppTester.isLMSHSE();
    const isFashionDeziiign = AppTester.isFashionDeziiign();
    const isMobile = useIsMobile();

    const isGeograffee = AppTester.isGeograffee();
    const isBooksMain = AppTester.isBooksMain();
    const isMediiiaMain = AppTester.isMediiiaMain();
    const isHSEDesign = AppTester.isHSEDesign();
    const isHseAnimation = AppTester.isHseAnimation()
    const {
        contextName: context,
        isCanCreateProject,
        teamId,
        moderationType,
        isLongreadDisabled,
    } = team;

    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
    const isGameDeziiign = AppTester.isGameDeziiign();
    const BookDesign = useMemo(() => (context === 'books_deziiign'), [context])

    const isDvaDesign = AppTester.isDvaDesign();
    const isGalllleryArt = AppTester.isGalllleryArt();
    const isCreativeCityUnit = useMemo(() => context === 'creativecityacademy', [context])
    const isModer = useMemo(() => profile && (bProfile.isModer(profile) || bProfile.isMiddleModer(profile)), [profile]);
    const teamHasLongread = (!!team?.longread || team?.longreadEntityLink !== '') && !isLongreadDisabled;
    const isLMSTeam = useMemo(() => moderationType === ModerationType.LMS, [moderationType])
    const isMainPageTeam = (isDvaDesign || isAgeytomesh || isCreativeCityUnit) && isMain;
    const isModulesLMSHSE = team?.moderationType === ModerationType.LMS;
    const isCompetitions = false; // This needs to be defined based on context
    const isKiiidsArt = AppTester.isKiiidsArt();
    const isDesignBooks = AppTester.isBooksMain();
    const isGalllleryBooks = AppTester.isBooksGallllery();
    const isPro = AppTester.isProDeziiign();
    const isHseSpace = AppTester.isHseSpace();
    const isGreenAward = AppTester.isGreenAward();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isCreativeHSE = AppTester.isContext('hsecreative');
    const isLMSHSECreative = AppTester.isContext('lmscreative');
    const isDeziiign = AppTester.isDeziiign();
    const isCompetitionEducation = AppTester.isCompetitionEducation();
    const isCompetition = AppTester.isCompetition();
    const shouldVisibleLgOrProjects = useMemo(() => (!!team?.isShowLongread || !!team?.isShowGridFirst), [team]);
    const visibleLGSelector = useSelector((state: any) => state.vt.longreadVisible);
    const hasForcedLanding = teamHasLongread;
    const visibleLG = teamHasLongread && (hasForcedLanding ? (teamHasLongread && ((team.isShowGridFirst && isForcedLanding) || (!team.isShowGridFirst && !isForcedLanding))) : visibleLGSelector);

    const isDropdownEnabled = isProDeziiign || isProHSE || isHseSpacePro;
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
    const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
    const onDropdownChange = (option: { label: string; value: string } | null) => {
        if (option) {
            setNavProTypeValue(option);
            history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
        }
    };

    const { contextButtons, hideSwitcherButtons } = useContextButtons(team, currentTab);
    
    useEffect(() => {
        //todo вынести дропдаун в отдельный компонент
        if (isDropdownEnabled) {
            urlApi()
                .getLendPresTagsTree(language)
                .then((tree: any[]) => {
                    const root = tree?.[0] || { additionalTags: [] };

                    const options = (root.additionalTags || []).map((tag: any) => {
                        const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === language);
                        return {
                            label: nameObj?.name || tag.title,
                            value: tag.tagId,
                        };
                    });

                    setProTypeOptions(options);

                    setNavProTypeValue(prev => {
                        if (!prev) return null;
                        return options.find((opt: any) => opt.value === prev.value) || null;
                    });
                })
                .catch((err: any) => {
                    console.error('Не удалось загрузить типы проектов', err);
                });
        }
    }, [language, isDropdownEnabled]);

    const { isChannel } = isTeamChannel(moderationType);

    const owner = useMemo(
        () => (profile && team && team?.owners?.find(
            (owner: Designer<'Global'>) => owner?.accountId === profile?.accountId) || undefined)
        , [team, isChannel]) as Designer | undefined

    const isTeamPreview = !!useRouteMatch([LinkTo.previewTeam]);

    const [teamPageLink, brndLink] = useMemo(() => {
        const basePath = isMainPageTeam ? '' : `/teams/${context || teamId}`
        return [`${basePath}`, `${basePath}/brnd`];
    }, [isLMSTeam, isMainPageTeam, context, teamId])

    const isCGRAVE = AppTester.isCGRAVE();
    const isShouldVisibleLMSButton = useMemo(
        () =>
            Boolean(
                (isLMSHSE || team?.moderationType == ModerationType.LMS) &&
                (team && (!!owner || isModer))
            ),
        [isLMSHSE, team, owner, isModer]
    );
    const createButtonTitle = useMemo(
        () =>
            isModulesLMSHSE || isLMSHSE
                ? t("nav.create_button.create_modul")
                : isCompetitions
                    ? t("nav.create_button.create_competition")
                    : isKiiidsArt ? t('nav.create_button.add_work_kiiids')
                        : isBooks || isDesignBooks || isGalllleryBooks
                            ? t("nav.create_button.create_book")
                            : isProDeziiign || isProHSE
                                ? t("nav.create_button.create_presentation")
                                : t("nav.create_button.create_project"),
        [isModulesLMSHSE, t, isCompetitions, isKiiidsArt, isBooks, isDesignBooks, isGalllleryBooks, isProDeziiign, isProHSE]
    );

    const shouldVisibleLGButton = useMemo(
        () => ((!!team?.isShowGridFirst || !!team?.isShowLongread) && teamHasLongread /*&& !visibleLG*/), [shouldVisibleLgOrProjects, visibleLG, team, teamHasLongread]);

    const setVisibleLG = (value: boolean) => {
        dispatch(setTeamLongread(value))
    }

    const onCreateClick = useCallback(() => {
        if (token) {
            history.push(BookDesign || isBooks ? CreateLinkTo.bookCreate() : CreateLinkTo.projectCreate());
        } else {
            emit('login');
        }
    }, [token, history, emit, BookDesign]);


    const buttonsTitle = useMemo(() => {
        if (teamId === 'b6a473594aee4b698cf0e49f52880df0') {
            return {
                titleFilled: language === 'ru' ? 'Перейти на сайт Школы дизайна НИУ ВШЭ' : 'Go to the HSE School of Design website',
                titleHollow: language === 'ru' ? 'Информация для абитуриентов Школы дизайна НИУ ВШЭ' : 'Information for applicants | HSE Art and Design School',
            }
        }
    }, [teamId, language])


    const isLMSContext = useMemo(() => context === 'lms' && !isLectureMedia, [context, isLectureMedia])

    const hasTeamEmblem = useMemo(
        () => ((!!team?.titleImages?.length && !!team?.isShowTeamEmblem))
        , [team]);


    const shouldDisplayEmblem = useMemo(() => (hasTeamEmblem || (isDafesMain)), [hasTeamEmblem, isDafesMain]);

    return (!!contextButtons?.length ?
        <ButtonWrapper
            fs
            className={'action-buttons'}
            buttonsWrap={contextButtons?.length > 2}
            hasEmblem={shouldDisplayEmblem && is992 && !is743}
            isLms={isLMSContext}
            emblemVisible={shouldDisplayEmblem}
            isFashionDeziiign={isFashionDeziiign}
        >
            {
                is430 && isCanCreateProject && (
                    <CreateBtn
                        className={'context-button'}
                        onClick={onCreateClick}
                        disabled={isTeamPreview}
                        importantStyles={!isHSEDesign && !BookDesign && !isCGRAVE && !isDeziiign && !isHseAnimation}
                        fixedSize
                    >
                        {createButtonTitle}
                    </CreateBtn>
                )
            }
            {contextButtons?.filter((button: any) => button.actionType !== ActionTypes.longread).map(({
                type,
                text: textRaw,
                textMobile,
                href,
                anchor,
                bgColor,
                actionType,
                hidden
            }: any) => {
                const text = isMobile ? (textMobile || textRaw) : textRaw;
                const isAnchor = !!anchor?.value?.length;
                const currentUtmParams = new URLSearchParams(window.location.search);
                const link = type?.includes('anchor')
                    ? `#${anchor?.value}`
                    : href?.includes('form')
                        ? `${href}${currentUtmParams.toString() ? `?${currentUtmParams.toString()}` : ''}`
                        : href?.includes('@') && !href?.startsWith('mailto:') && !href?.startsWith('http')
                            ? `mailto:${href}`
                            : href;
                const isMailtoLink = link?.startsWith('mailto:');
                const isButtonHidden = hidden;


                if (isButtonHidden || !text?.length) return false;

                if (isSpecialButton(actionType || '')) {
                    return (
                        <SpecialTypeButtons
                            hide={hideSwitcherButtons}
                            type={type}
                            text={text}
                            specialType={actionType}
                            team={team}
                        />
                    )
                }

                if (actionType === ActionTypes.showcase && shouldVisibleLGButton) {
                    return <SwitcherButtons hide={hideSwitcherButtons} isShouldVisibleLMSButton={isShouldVisibleLMSButton}
                        type={type} text={text} action={() => { /*setQueryParams({ lgvisible: true });*/
                            setVisibleLG(true)
                            if (hasForcedLanding) {
                                history.push(team.isShowGridFirst ? brndLink : teamPageLink);
                            }
                        }} />
                }

                if (actionType === ActionTypes.showcase && !shouldVisibleLGButton) {
                    return false;
                }

                if (type === 'filled') {
                    return (
                        <>
                            {isAnchor && !isMailtoLink ? (
                                <ExploreButtonFilled className={'filled-button context-button'}
                                    // importantStyles={!isHSEDesign && !BookDesign}
                                    fixedSize
                                    customBG={bgColor}
                                    isGreenBG={isAgeytomesh}
                                    disabled={isTeamPreview}
                                    onClick={() => {
                                        history.push(location.pathname + link)
                                        setVisibleLG(true);
                                    }}
                                >
                                    {text}
                                </ExploreButtonFilled>
                            ) : (
                                <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleFilled } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                    <ExploreButtonFilled
                                        className={'filled-button'}
                                        // importantStyles={!isHSEDesign && !BookDesign}
                                        fixedSize
                                        customBG={bgColor}
                                        isGreenBG={isAgeytomesh}
                                        disabled={isTeamPreview}
                                    >
                                        {text}
                                    </ExploreButtonFilled>
                                </a>
                            )}
                        </>
                    )
                }

                if (type === 'filled-blue') {
                    return (
                        <>
                            {isAnchor && !isMailtoLink ? (
                                <ExploreButtonFilled className={'filled-button context-button'}
                                    // importantStyles={!isHSEDesign && !BookDesign}
                                    fixedSize
                                    customBG="#182c65"
                                    isGreenBG={isAgeytomesh}
                                    disabled={isTeamPreview}
                                    onClick={() => {
                                        history.push(location.pathname + link)
                                        setVisibleLG(true);
                                    }}
                                >
                                    {text}
                                </ExploreButtonFilled>
                            ) : (
                                <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleFilled } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                    <ExploreButtonFilled
                                        className={'filled-button'}
                                        // importantStyles={!isHSEDesign && !BookDesign}
                                        fixedSize
                                        customBG="#182c65"
                                        isGreenBG={isAgeytomesh}
                                        disabled={isTeamPreview}
                                    >
                                        {text}
                                    </ExploreButtonFilled>
                                </a>
                            )}
                        </>
                    )
                }
                return (
                    <>
                        {isAnchor && !isMailtoLink ? (
                            <ExploreButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button anchor-button context-button'}
                                onClick={() => {
                                    if (hasForcedLanding) {
                                        history.push(team.isShowGridFirst ? brndLink : teamPageLink);
                                    } else {
                                        setVisibleLG(true)
                                    }
                                    setTimeout(() => {
                                        history.replace(window.location.pathname + link)
                                    }, 100)
                                }}>
                                {text}
                            </ExploreButtonHollow>
                        ) : (
                            <a href={link} {...(buttonsTitle ? { title: buttonsTitle.titleHollow } : {})} target={isMailtoLink ? "_self" : "_blank"} rel="noreferrer" className='context-button'>
                                <ExploreButtonHollow disabled={isTeamPreview} fixedSize className={'hollow-button'}>
                                    {text}
                                </ExploreButtonHollow>
                            </a>
                        )}
                    </>
                )
            })}

        </ButtonWrapper> : (!isShouldVisibleLMSButton && !(isProDeziiign || isPro || isHseSpacePro || isMediiiaMain || isAcademy || isHseSpace || isDeziiign || isGameDeziiign || isGreenAward || isAdcrDafesNet || isCreativeHSE || isLMSHSECreative || isHSEDesign || isGalllleryArt || isGreenAward || isCompetitionEducation || isCompetition)) ? null : isCanCreateProject && is430 ? (
            <ButtonWrapper
                fs
                className={'action-buttons'}
                buttonsWrap={contextButtons?.length === 3}
                hasEmblem={shouldDisplayEmblem && is992 && !is743}
                isLms={isLMSContext}
                emblemVisible={shouldDisplayEmblem}
                isFashionDeziiign={isFashionDeziiign}
            >
                {isDropdownEnabled ? (
                    <DropdowCreateProjectnWrapper>
                        <ProjectEditPageGridInput isTeamEdit isColumns>
                            <CustomDropdown
                                value={navProTypeValue}
                                onChange={onDropdownChange}
                                options={proTypeOptions}
                                placeholder={isGeograffee ? t('nav.create_project') :
                                    isBooksMain ? t('nav.create_button.create_book') :
                                        isProDeziiign || isPro || isHseSpacePro ? t('nav.create_button.create_presentation') :
                                            t('nav.create')}
                            />
                        </ProjectEditPageGridInput>

                    </DropdowCreateProjectnWrapper>
                ) : (
                    <CreateBtn
                        className='context-button'
                        onClick={onCreateClick}
                        disabled={isTeamPreview}
                        // importantStyles={!isHSEDesign && !BookDesign}
                        fixedSize
                    >
                        {createButtonTitle}
                    </CreateBtn>
                )}
            </ButtonWrapper>
        ) : null);
}

export default TeamButtons;